const trendingVenues = [
    {
        id: 1,
        venueImage:
            'https://img.freepik.com/free-photo/delicious-coffee-cups-with-plants_23-2150708034.jpg?t=st=1721905456~exp=1721909056~hmac=57a1b3db10e2ad345b9a57564fcc7cf6c916bc4046674c9c9523e9f9d8cf4ed4&w=1060',
        venueTitle: 'Summer Music Night Club',
        venueLocation: 'Radhe Krishna Restaurant, Vesu',
        venuePricing: '₹1,100 for two',
        venueTime: 'Opens at 10:00 am',
        venueCategory: 'Cafe',
        venueRatings: '4.2'
    },
    {
        id: 2,
        venueImage:
            'https://img.freepik.com/free-photo/front-view-bartender-preparing-drink_23-2150347012.jpg?t=st=1721905611~exp=1721909211~hmac=0951f25070e8901eb1fb1aaf07625df35c853b3a9029ad81ecf46aae64218c7f&w=1060',
        venueTitle: 'City Lights Bar',
        venueLocation: 'Downtown, San Francisco',
        venuePricing: '₹2,000 for two',
        venueTime: 'Opens at 8:00 pm',
        venueCategory: 'Bar',
        venueRatings: '4.8'
    },
    {
        id: 3,
        venueImage:
            'https://img.freepik.com/free-photo/digital-lavender-style-interior-design_23-2151561220.jpg?t=st=1721905627~exp=1721909227~hmac=d2f974fa029359712a0f31c2fd21656ab567171a9229fae0f9644db51504532a&w=1380',
        venueTitle: 'Gourmet Garden',
        venueLocation: 'Uptown, New York',
        venuePricing: '₹3,500 for two',
        venueTime: 'Opens at 11:00 am',
        venueCategory: 'Restaurant',
        venueRatings: '4.7'
    },
    {
        id: 4,
        venueImage:
            'https://img.freepik.com/free-photo/modern-interior-restaurant-illustration_1409-7426.jpg?t=st=1721905764~exp=1721909364~hmac=f18d380c8c9f5fa638c72a2482a27e1f3bf5c237ce75a876a534971fc2502e5f&w=1060',
        venueTitle: 'Sunset Bistro',
        venueLocation: 'Seaside, Miami',
        venuePricing: '₹2,200 for two',
        venueTime: 'Opens at 5:00 pm',
        venueCategory: 'Bistro',
        venueRatings: '4.5'
    },
    {
        id: 5,
        venueImage:
            'https://img.freepik.com/free-photo/dark-club-with-people-dancing-one-lights-is-lit-up_1340-32805.jpg?t=st=1721905550~exp=1721909150~hmac=9cc9576089f9047ca681fcbee84b9825ef92344735c9c03aa7e808838449d8e6&w=1060',
        venueTitle: 'Night Owl Club',
        venueLocation: 'Main Street, Los Angeles',
        venuePricing: '₹1,500 for two',
        venueTime: 'Opens at 9:00 pm',
        venueCategory: 'Club',
        venueRatings: '4.6'
    },
    {
        id: 6,
        venueImage:
            'https://img.freepik.com/free-photo/photorealistic-wedding-venue-with-intricate-decor-ornaments_23-2151481522.jpg?t=st=1721905601~exp=1721909201~hmac=6ee1314b15098c74cd6a83cb927b2546b426004e172af825252f6575f51af22c&w=1060',
        venueTitle: 'Elite Eatery',
        venueLocation: 'Business District, Chicago',
        venuePricing: '₹4,000 for two',
        venueTime: 'Opens at 12:00 pm',
        venueCategory: 'Fine Dining',
        venueRatings: '4.9'
    },
    {
        id: 7,
        venueImage:
            'https://img.freepik.com/free-photo/warmth-cafe-dull-day-oslo_53876-139512.jpg?t=st=1721905489~exp=1721909089~hmac=3732088fd35d4bbc0485db068d324423fed7cc5f5b922d1ef0d0eff3387e7c7f&w=1060',
        venueTitle: 'Morning Glory Cafe',
        venueLocation: 'Old Town, Boston',
        venuePricing: '₹800 for two',
        venueTime: 'Opens at 7:00 am',
        venueCategory: 'Cafe',
        venueRatings: '4.3'
    },
    {
        id: 8,
        venueImage:
            'https://img.freepik.com/free-photo/three-bearded-interracial-friends-drink-craft-beer-talk-brewery-two-hipster-workers-aprons-drink-beer-with-their-friend-brewery-factory-old-friends-gathered-drink-beer-chat_613910-5444.jpg?t=st=1721905805~exp=1721909405~hmac=8077ffa5e21921c31cf607ea47f8c39127285124b6694766e2cf63afe69928b9&w=1060',
        venueTitle: 'Urban Taphouse',
        venueLocation: 'Midtown, Seattle',
        venuePricing: '₹2,500 for two',
        venueTime: 'Opens at 6:00 pm',
        venueCategory: 'Taphouse',
        venueRatings: '4.4'
    }
];

export default trendingVenues;
